import createSagaMiddleware from 'redux-saga'
import rootSagas from './stores/rootSaga'
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './stores/rootReducer.js';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  }).concat(sagaMiddleware,),
});


sagaMiddleware.run(rootSagas);

export default store;